import { shouldUseIonicComponents } from "../../utils/platformUtils";

/**
 * Hook that returns platform UI preferences.
 * Use this when you need to branch logic or render different layouts
 * (e.g. IonContent vs div, IonModal vs Drawer) rather than just swapping primitives.
 *
 * @returns {{ useIonic: boolean }} useIonic is true on iOS/Android, false on web
 */
export const usePlatformUI = () => {
  return {
    useIonic: shouldUseIonicComponents()
  };
};

export default usePlatformUI;
